import React from "react";
import DoctorPhoto from "./DoctorPhoto";
import WebsiteButton from "./WebsiteButton";

class DoctorInfo extends React.Component {
  render() {
    const { name, photoUrl, websiteUrl } = this.props;

    return (
      <div className="doctor-section">
        <h1>Interested in Learning More?</h1>

        <DoctorPhoto photoUrl={photoUrl} name={name} />

        <p>
          Visit {name}
          ’s website today to learn more about the procedures and services
          offered.
        </p>

        {websiteUrl && <WebsiteButton websiteUrl={websiteUrl} />}
      </div>
    );
  }
}

export default DoctorInfo;
